export default __webpack_public_path__ + "./image/26a063b8d0ccd17d482fe2c9b1ff4889.png";